import { Dashboard } from "views/dashboard/dashboard";
import { Help } from "views/dashboard/help";
import { OnboardingView } from "views/onboarding/onboarding";
import { HubSpotConnectComplete } from "views/integration/hubspot-complete";
import { VerificationView } from "views/verification/verification";
import { LandingView } from "views/landing/landing";
import { DirectVerification } from "views/verification/direct-verification";
import { SanctionsView } from "views/verification/sanctions";
import { AdverseMediaView } from "views/verification/adverse";
import { AdminResponseView } from "views/verification/admin-response";
import { UsCriminalCheckResultsView } from "views/verification/us-criminal";
import { RiskAssessmentView } from "views/verification/risk-assessment";
import { EddCaseView } from "views/verification/edd-case";
import { PeriodicReviewDetailView } from "views/verification/periodic-review-detail";
import { ReferralView } from "views/dashboard/referral";
import { StaffVerification } from "views/verification/staff-verification";
import { KYBView  } from "views/dashboard/kyb";
import { ClientGroupsView } from "views/account/client-groups";
import { ClientGroupDetailView } from "views/account/client-group-detail";
import { ClientOnboardingSettingsView } from "views/account/client-onboarding-settings";
import { ClientOnboardingV2SettingsView } from "views/account/client-onboarding-v2-settings";
import { EntityOnboardingStartView } from "views/entity-onboarding/start";
import { EntityOnboardingReportView } from "views/entity-onboarding/report";
import { ScreeningView } from "views/screening/screening";
import { WorkflowView } from "views/workflow/workflow";

const Routes = [
  {
    path: "/dashboard",
    view: Dashboard,
    layout: "app",
    permission: "user",
    title: "Dashboard",
  },
  {
    path: "/welcome",
    view: OnboardingView,
    layout: "onboarding",
    permission: "user",
    title: "Welcome",
  },
  {
    // Where the HubSpot OAuth connector returns users. Singular /integration/
    // matches the existing /integration/trigger/:token namespace. Lives here
    // rather than beside the integration settings pages, which are admin-only,
    // because this one has to serve the onboarding user too.
    path: "/integration/hubspot/complete",
    view: HubSpotConnectComplete,
    layout: "onboarding",
    permission: "user",
    title: "Finishing HubSpot setup",
  },
  {
    path: "/help",
    view: Help,
    layout: "app",
    permission: "user",
    title: "Get Help",
  },
  {
    path: "/help/:slug",
    view: Help,
    layout: "app",
    permission: "user",
    title: "Get Help",
  },
  {
    path: "/refer",
    view: ReferralView,
    layout: "app",
    permission: "user",
    title: "Refer a friend",
  },
  {
    path: "/verification/:id",
    view: VerificationView,
    layout: "app",
    permission: "user",
    title: "Verification view",
  },
  {
    path: "/verification/risk-assessment/:id",
    view: RiskAssessmentView,
    layout: "app",
    permission: "user",
    title: "Risk Assessment",
  },
  {
    path: "/verification/edd/:id",
    view: EddCaseView,
    layout: "app",
    permission: "user",
    title: "Enhanced Due Diligence Case",
  },
  {
    path: "/verification/periodic-review/:id",
    view: PeriodicReviewDetailView,
    layout: "app",
    permission: "user",
    title: "Resolve Periodic Review",
  },
  {
    path: "/verification/sanctions/:id",
    view: SanctionsView,
    layout: "app",
    permission: "user",
    title: "PEP/Sanctions view",
  },
  {
    path: "/direct-verification",
    view: DirectVerification,
    layout: "app",
    permission: "user",
    title: "Direct Verification",
  },
  {
    path: "/landing",
    view: LandingView,
    layout: "app",
    permission: "user",
    title: "Dashboard",
  },
  {
    path: "/verification/adverse/:id",
    view: AdverseMediaView,
    layout: "app",
    permission: "user",
    title: "Adverse Media Results",
  },
  {
    path: "/verification/us-criminal-v1/:id",
    view: UsCriminalCheckResultsView,
    layout: "app",
    permission: "user",
    title: "US Criminal Check Results",
  },
  {
    path: "/verification/:verification_id/response/:id",
    view: AdminResponseView,
    layout: "app",
    permission: "user",
    title: "Verification Response",
  },
  {
    path: "/screening",
    view: ScreeningView,
    layout: "app",
    permission: "user",
    title: "Screening",
  },
  {
    path: "/workflow",
    view: WorkflowView,
    layout: "app",
    permission: "admin",
    title: "Workflows",
  },
  {
    path: "/kyb",
    view: KYBView,
    layout: "app",
    permission: "user",
    title: "Know Your Business",
  },
  {
    path: "/staff-verification",
    view: StaffVerification,
    layout: "app",
    permission: "user",
    title: "Staff Verification",
  },
  {
    path: "/client-groups",
    view: ClientGroupsView,
    layout: "app",
    permission: "user",
    title: "Client Groups",
  },
  {
    path: "/client-groups/:id",
    view: ClientGroupDetailView,
    layout: "app",
    permission: "user",
    title: "Client Group Detail",
  },
  {
    path: "/client-onboarding-settings",
    view: ClientOnboardingSettingsView,
    layout: "app",
    permission: "user",
    title: "Client Onboarding Settings",
  },
  {
    path: "/client-onboarding-v2-settings",
    view: ClientOnboardingV2SettingsView,
    layout: "app",
    permission: "user",
    title: "Client Onboarding v2 Settings",
  },
  {
    path: "/entity-onboarding",
    view: EntityOnboardingStartView,
    layout: "app",
    permission: "user",
    title: "Entity Onboarding",
  },
  {
    path: "/entity-onboarding/reports/:report_id",
    view: EntityOnboardingReportView,
    layout: "app",
    permission: "user",
    title: "UBO Report",
  },
];

export default Routes;
